import { RouterProvider as AriaRouterProvider } from "@heroui/react/rac";
import { Outlet, useHref, useNavigate } from "react-router";

/**
 * Branche les composants HeroUI sur React Router.
 *
 * HeroUI est bâti sur React Aria, dont les `Link` (et tout composant acceptant
 * un `href`) déclenchent par défaut une **navigation navigateur** : la page est
 * rechargée, l'état React perdu, la session relue depuis le stockage. Ce
 * fournisseur leur donne le `navigate` du routeur, ce qui les rend
 * indistinguables d'un `<Link>` de React Router — tout en gardant une vraie
 * ancre, donc le clic milieu et « ouvrir dans un nouvel onglet ».
 *
 * ⚠️ Il doit vivre **à l'intérieur** du routeur : `useNavigate` et `useHref`
 * n'existent pas hors de son contexte. D'où cette route de mise en page
 * racine, plutôt qu'un provider dans `App.tsx`.
 */
export function AriaRouting() {
  const navigate = useNavigate();

  return (
    <AriaRouterProvider navigate={navigate} useHref={useHref}>
      <Outlet />
    </AriaRouterProvider>
  );
}
